import axios from '@/utils/ajax'
import Auth from '@/utils/auth'

const state = {
  token: ''
}

const mutations = {
  setToken: (state, data) => {
    if (data) {
      Auth.setToken(data)
      Auth.setLoginStatus()
    } else {
      Auth.removeToken()
      Auth.removeLoginStatus()
    }
    state.token = data
  }
}

const actions = {
  login ({commit}, userInfo) {
    return new Promise(resolve => {
      axios({
        url: '/login',
        method: 'post',
        data: {
          ...userInfo
        }
      }).then(res => {
        if (res.login) {
          commit('setToken', res.token)
          commit('user/setName', res.name, {root: true})
        }
        resolve(res)
      })
    })
  },

  // 登出
  logout ({commit}) {
    return new Promise(resolve => {
      commit('setToken', '')
      commit('user/setName', '', {root: true})
      resolve()
    })
  },

  // 获取新的token
  getNewToken ({commit, state}) {
    return new Promise(resolve => {
      axios({
        url: '/getToken',
        method: 'get',
        param: {
          token: state.token
        }
      }).then(res => {
        commit('setToken', res.token)
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js